export * from "./pants.svg";

export const z = 5;
